import { render, staticRenderFns } from "./NextButton.component.vue?vue&type=template&id=c98a68c8&"
import script from "./NextButton.component.vue?vue&type=script&lang=ts&"
export * from "./NextButton.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports